// Common
import common from "./locales.json";

// Login
import { locales as login } from "../../pages/Login/locales";
import { locales as register } from "../../pages/Register/locales";
// import { locales as login_qr } from '../../pages/LoginQr/locales';
import { locales as forgetpassword } from "../../pages/ForgetPassword/locales";
import { locales as resetPassword } from "../../pages/ResetPassword/locales";
import { locales as blockedUser } from "../../pages/BlockedUser/locales";

import { locales as dashboard } from "../../pages/Dashboard/locales";
import { locales as users } from "../../containers/Users/locales";
import { locales as add_user } from "../../containers/Users/AddUser/locales";
import { locales as edit_user } from "../../containers/Users/EditUser/locales";

import { locales as projects } from "../../containers/Projects/locales";
import { locales as add_projects } from "../../containers/Projects/AddProject/locales";
import { locales as edit_projects } from "../../containers/Projects/EditProject/locales";
import { locales as roles } from "../../containers/Roles/locales";
import { locales as add_roles } from "../../containers/Roles/AddRole/locales";
import { locales as role_pages } from "../../containers/RolePages/locales";
import { locales as transactions } from "../../containers/Transactions/locales";
import { locales as reports } from "../../containers/Reports2/locales";
import { locales as registrationOfCustomer } from "../../containers/Onboarding/locales";
import { locales as banks } from "../../containers/Banks/locales";
import { locales as commission } from "../../containers/Commission/locales";
import { locales as accountBalance } from "../../containers/AccountBalance/locales";
import { locales as mcc } from "../../containers/MccCertificate/locales";
import { locales as merchantAccountBalance } from "../../containers/MerchantAccountBalance/locales";
import { locales as approvements } from "../../containers/Approvements/locales";
import { locales as bankCard } from "../../containers/BankCards/locales";
import { locales as bankMerchant } from "../../containers/BanksMerchants/locales";
import { locales as bankTransaction } from "../../containers/BanksTransactions/locales";
import { locales as endUsers } from "../../containers/PayzeeEndUsers/locales";
import { locales as merchantEndUsers } from "../../containers/MerchantEndUsers/locales";
import { locales as paymentHistory } from "../../containers/PaymentHistory/locales";
import { locales as widgetPage } from "../../containers/WidgetPage/locales";
import { locales as mailSms } from "../../containers/MailSms/locales";
import { locales as binList } from "../../containers/BinList/locales";
import { locales as payment } from "../../containers/CreatePayLink/locales";
import { locales as transferLimits } from "../../containers/TransferLimits/locales";
import { locales as kioskDefinitions } from "../../containers/KioskDefinitions/locales";
import { locales as manuelAdjustment } from "../../containers/ManuelAdjustment/locales";
import { locales as constantLinks } from "../../pages/PayByConstantLink/locales";
import { locales as payByLink } from "../../pages/PayByLink/locales";
import { locales as paymentCard } from "../../pages/PaymentPage/locales";
import { locales as monthlyReport } from "../../containers/MonthlyReportForMerchant/locales";
import { locales as summaryReport } from "../../containers/SummaryReport/locales";
import { locales as summaryReportForAdmin } from "../../containers/SummaryReportForAdmin/locales";

import { locales as accountActivitiesForAdmin } from "../../containers/AccountActivitiesForAdmin/locales";
import { locales as accountActivities } from "../../containers/AccountActivities/locales";

import { locales as merchantBankIds } from "../../containers/MerchantBankIds/locales";


// Turkish
common["tr"].login = login["tr"];
common["tr"].register = register["tr"];
common["tr"].paymentCard = paymentCard["tr"];
// common['tr'].login_qr = login_qr['tr'];
common["tr"].forgetpassword = forgetpassword["tr"];
common["tr"].resetpassword = resetPassword["tr"];
common["tr"].dashboard = dashboard["tr"];

common["tr"].users = users["tr"];
common["tr"].add_user = add_user["tr"];
common["tr"].edit_user = edit_user["tr"];
common["tr"].projects = projects["tr"];
common["tr"].add_projects = add_projects["tr"];
common["tr"].edit_projects = edit_projects["tr"];
common["tr"].roles = roles["tr"];
common["tr"].add_roles = add_roles["tr"];
common["tr"].role_pages = role_pages["tr"];
common["tr"].transactions = transactions["tr"];
common["tr"].reports = reports["tr"];
common["tr"].registrationOfCustomer = registrationOfCustomer["tr"];
common["tr"].banks = banks["tr"];
common["tr"].commissions = commission["tr"];
common["tr"].accountBalance = accountBalance["tr"];
common["tr"].mcc = mcc["tr"];
common["tr"].merchantAccountBalance = merchantAccountBalance["tr"];
common["tr"].approvements = approvements["tr"];
common["tr"].bankCard = bankCard["tr"];
common["tr"].bankMerchant = bankMerchant["tr"];
common["tr"].bankTransaction = bankTransaction["tr"];

common["tr"].endUsers = endUsers["tr"];
common["tr"].paymentHistory = paymentHistory["tr"];
common["tr"].summaryReport = summaryReport["tr"];
common["tr"].summaryReportForAdmin = summaryReportForAdmin["tr"];

common["tr"].accountActivitiesForAdmin = accountActivitiesForAdmin["tr"];
common["tr"].merchantBankIds = merchantBankIds["tr"];

common["tr"].accountActivities = accountActivities["tr"];

common["tr"].widgetPage = widgetPage["tr"];
common["tr"].mailSms = mailSms["tr"];
common["tr"].binList = binList["tr"];
common["tr"].merchantEndUsers = merchantEndUsers["tr"];
common["tr"].payment = payment["tr"];
common["tr"].transferLimits = transferLimits["tr"];
common["tr"].kioskDefinitions = kioskDefinitions["tr"];
common["tr"].manuelAdjustment = manuelAdjustment["tr"];
common["tr"].payByLink = payByLink["tr"];
common["tr"].blockedUser = blockedUser["tr"];
common["tr"].monthlyReport = monthlyReport["tr"];
// English
common["en"].login = login["en"];
common["en"].register = register["en"];
common["en"].forgetpassword = forgetpassword["en"];
common["en"].dashboard = dashboard["en"];
common["en"].manuelAdjustment = manuelAdjustment["en"];
common["en"].payByLink = payByLink["en"];
common["en"].users = users["en"];
common["en"].add_user = add_user["en"];
common["en"].edit_user = edit_user["en"];
common["en"].projects = projects["en"];
common["en"].add_projects = add_projects["en"];
common["en"].edit_projects = edit_projects["en"];
common["en"].roles = roles["en"];
common["en"].add_roles = add_roles["en"];
common["en"].role_pages = role_pages["en"];
common["en"].transactions = transactions["en"];
common["en"].reports = reports["en"];
common["en"].registrationOfCustomer = registrationOfCustomer["en"];
common["en"].banks = banks["en"];
common["en"].commissions = commission["en"];
common["en"].accountBalance = accountBalance["en"];
common["en"].mcc = mcc["en"];
common["en"].merchantAccountBalance = merchantAccountBalance["en"];
common["en"].approvements = approvements["en"];
common["en"].bankCard = bankCard["en"];
common["en"].bankMerchant = bankMerchant["en"];
common["en"].bankTransaction = bankTransaction["en"];
common["en"].endUsers = endUsers["en"];
common["en"].paymentHistory = paymentHistory["en"];
common["en"].summaryReport = summaryReport["en"];
common["en"].summaryReportForAdmin = summaryReportForAdmin["en"];
common["en"].accountActivitiesForAdmin = accountActivitiesForAdmin["en"];
common["en"].merchantBankIds = merchantBankIds["en"];
common["en"].accountActivities = accountActivities["en"];

common["en"].widgetPage = widgetPage["en"];
common["en"].mailSms = mailSms["en"];
common["en"].binList = binList["en"];
common["en"].merchantEndUsers = merchantEndUsers["en"];
common["en"].payment = payment["en"];
common["en"].transferLimits = transferLimits["en"];
common["en"].kioskDefinitions = kioskDefinitions["en"];
common["en"].constantLinks = constantLinks["en"];
common["en"].resetpassword = resetPassword["en"];
common["en"].blockedUser = blockedUser["en"];

export { common };
